import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import columns from './columns';

const ProgenySales = ({ data: { progenySales } }) => (
    <section className="hp-progeny-sales">
        <RpTable
            columns={columns}
            data={progenySales}
            initialSortIdx={0}
            noDataText="No progeny sales"
            sortable
        />
    </section>
);

ProgenySales.propTypes = {
    data: PropTypes.shape({
        progenySales: PropTypes.arrayOf(PropTypes.shape({
            horseName: PropTypes.string,
            horseCountryOriginCode: PropTypes.string,
            horseUid: PropTypes.number,
            horseFirstColourCode: PropTypes.string,
            horseSex: PropTypes.string,
            horseAge: PropTypes.number,
            sireName: PropTypes.string,
            sireUid: PropTypes.number,
            sireCountryOriginCode: PropTypes.string,
            sireOfDamName: PropTypes.string,
            sireOfDamCountryOriginCode: PropTypes.string,
            sireOfDamUid: PropTypes.number,
            saleDate: PropTypes.string,
            priceGbp: PropTypes.number,
            price: PropTypes.number,
            curCode: PropTypes.string,
            vendor: PropTypes.string,
            buyerDetail: PropTypes.string,
            venueDesc: PropTypes.string,
        })),
    }).isRequired,
};

export default ProgenySales;



// WEBPACK FOOTER //
// ./src/js/horse/progenySales/ProgenySales.jsx